$(document).on('turbolinks:load', function () {
  $('.form-check-input').each(function () {
    if ($(this).is(":checked")) {
        $(this).parent().siblings('.additional-info').show();
    } else {
        $(this).parent().siblings('.additional-info').hide();
    }
  })


  $(".form-check-input").change(function() {
    var index = $(this).data("index");
    var additionalInfo = $("#additional-info-" + index);
    if ($(this).is(":checked")) {
        additionalInfo.show();
    } else {
        additionalInfo.hide();
        additionalInfo.find('input.form-control').val('');
        additionalInfo.find("select option").prop("selected", false)
    }
  });
});
